import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["fill", "height", "width"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M23.0988 18H23.2889C23.8669 18 24.3508 18.438 24.4083 19.0131L25.432 29.25L32.7402 33.4261C33.0907 33.6264 33.307 33.9992 33.307 34.4029V34.875C33.307 35.3496 32.9223 35.7343 32.4478 35.7343C32.3714 35.7343 32.2954 35.7241 32.2217 35.704L21.829 32.8696C21.3084 32.7277 20.962 32.236 21.0033 31.698L21.9771 19.0387C22.0222 18.4526 22.511 18 23.0988 18Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  opacity: "0.3",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M17.377 6.58954C20.2174 5.38011 23.343 4.71088 26.625 4.71088C39.6727 4.71088 50.25 15.2882 50.25 28.3359C50.25 41.3836 39.6727 51.9609 26.625 51.9609C13.5773 51.9609 3 41.3836 3 28.3359C3 26.1199 3.30509 23.9752 3.87555 21.9415L8.20832 23.1569C7.74012 24.826 7.5 26.5627 7.5 28.3359C7.5 38.8983 16.0626 47.4609 26.625 47.4609C37.1875 47.4609 45.75 38.8983 45.75 28.3359C45.75 17.7734 37.1875 9.21088 26.625 9.21088C24.4847 9.21088 22.4003 9.56172 20.4346 10.2334L23.1138 13.4264C23.2698 13.6123 23.3615 13.8436 23.3752 14.0859C23.4104 14.7062 22.936 15.2376 22.3157 15.2727L11.365 15.8933C11.256 15.8995 11.1466 15.8897 11.0403 15.8644C10.436 15.7202 10.0629 15.1134 10.2071 14.5091L12.7462 3.86401C12.8022 3.6291 12.9324 3.41846 13.1174 3.26323C13.5933 2.86385 14.3029 2.92593 14.7023 3.40189L17.377 6.58954Z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    viewBox: "0 0 54 54",
    fill: _ctx.color,
    height: _ctx.size,
    width: _ctx.size,
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
  }, _hoisted_4, 8, _hoisted_1))
}